import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'select-with-other',
    templateUrl: './select-with-other.component.html',
    styleUrls: ['./select-with-other.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectWithOtherComponent),
            multi: true
        }
    ]
})
export class SelectWithOtherComponent implements ControlValueAccessor {

    @Input('data') Data: { Id?: any, Label: string }[] = [];
    @Input('placeholder') Placeholder: string = 'Indique o valor';
    @Input('otherLabel') OtherLabel: string = 'Outro';
    @Input('selectPlaceholder') SelectPlaceholder: string = 'selecione uma opção';

    public readonly OtherValue: string = '__OTHER__';
    public IsDisabled: boolean = false;
    public Value: string = '';

    // sinaliza intenção explícita do utilizador ao escolher "Outro" (Value ainda vazio nesse instante)
    private ManualOtherSelected: boolean = false;

    private onChange: (value: string) => void = () => { };
    private onTouched: () => void = () => { };

    // getter puro: nunca fica dessincronizado de Data/Value, independente da ordem writeValue/ngOnChanges
    public get IsCustomValue(): boolean {

        return this.ManualOtherSelected || ((this.Data?.length > 0) && !!this.Value && !this.Data.some(it => it?.Label === this.Value));
    }

    writeValue(value: string): void {

        this.Value = value || '';
        this.ManualOtherSelected = false;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.IsDisabled = isDisabled;
    }

    public get SelectValue(): string {

        return this.IsCustomValue ? this.OtherValue : (this.Value || '');
    }

    /**
     *
     * @param ev
     */
    public OnChangeSelect(ev: any) {

        const value = ev?.detail?.value;

        if (value === this.OtherValue) {
            this.ManualOtherSelected = true;
            this.Value = '';
        }
        else {
            this.ManualOtherSelected = false;
            this.Value = value;
        }

        this.onChange(this.Value);
        this.onTouched();
    }

    /**
     *
     * @param ev
     */
    public OnChangeInput(ev: any) {

        this.Value = ev?.detail?.value ?? '';

        this.onChange(this.Value);
        this.onTouched();
    }
}
